import { ActiveFilters } from 'store/search/types';

interface DependencyParams {
  query: string;
  pageNr: number;
  sortBy: string;
  filters: ActiveFilters;
}

export default function getQueryStringHash(params: DependencyParams) {
  const { query, sortBy, filters } = params;
  return JSON.stringify({ query, sortBy, filters });
}
